/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_FunctionsInputs */

const en_gc_resources_features_functions = /** @type {(inputs: Gc_Resources_Features_FunctionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than 500 spreadsheet functions.`)
};

const zh_gc_resources_features_functions = /** @type {(inputs: Gc_Resources_Features_FunctionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 500 多种电子表格函数。`)
};

/**
* | output |
* | --- |
* | "More than 500 spreadsheet functions." |
*
* @param {Gc_Resources_Features_FunctionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_functions = /** @type {((inputs?: Gc_Resources_Features_FunctionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_FunctionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_functions(inputs)
	return zh_gc_resources_features_functions(inputs)
});
export { gc_resources_features_functions as "gc.resources.features.functions" }